import { render, staticRenderFns } from "./DrawerConfigBackSection.vue?vue&type=template&id=0a1d19a6&"
import script from "./DrawerConfigBackSection.vue?vue&type=script&lang=js&"
export * from "./DrawerConfigBackSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports